(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[800],{

/***/ 73276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop",
      function () {
        return __webpack_require__(53871);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CategoryNavigation_CategoryNavigation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ui/links/CustomA.tsx
var CustomA = __webpack_require__(70378);
;// CONCATENATED MODULE: ./components/shop/CategoryNavigation/CategoryNavigationItem.tsx








var CategoryNavigationItem = function(param) {
    var _category = param.category, slug = _category.slug, name = _category.name, url = _category.smallImage.url, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/shop/".concat(slug, "#product-list"),
        passHref: true,
        scroll: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomA/* default */.Z, {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: url,
                        quality: 75,
                        width: 133,
                        height: 133
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: classnames_default()(classes.text, isSelected && classes.textSelected),
                    variant: "h6",
                    component: "h2",
                    children: name
                })
            ]
        })
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            display: "flex",
            flexDirection: "column"
        },
        text: (0,_define_property/* default */.Z)({
            fontWeight: 400,
            fontSize: "0.85rem",
            textAlign: "center"
        }, "&:hover", {
            textDecoration: "underline"
        }),
        textSelected: {
            fontWeight: 700,
            color: theme.palette.primary.main
        }
    };
});
/* harmony default export */ var CategoryNavigation_CategoryNavigationItem = (CategoryNavigationItem);

;// CONCATENATED MODULE: ./components/shop/CategoryNavigation/CategoryNavigation.tsx





var CategoryNavigation = function(param) {
    var categories = param.categories, _categorySlug = param.categorySlug, categorySlug = _categorySlug === void 0 ? "" : _categorySlug;
    var classes = CategoryNavigation_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: classes.container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.grid,
            children: categories.map(function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryNavigation_CategoryNavigationItem, {
                    category: category,
                    isSelected: categorySlug === category.slug
                }, category.sys.id);
            })
        })
    });
};
var CategoryNavigation_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: {
            marginBottom: theme.spacing(6)
        },
        grid: (0,_define_property/* default */.Z)({
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))"
        }, theme.breakpoints.up("sm"), {
            gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))",
            gap: 4
        })
    };
});
/* harmony default export */ var CategoryNavigation_CategoryNavigation = (CategoryNavigation);


/***/ }),

/***/ 53871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78690);
/* harmony import */ var components_shop_CategoryNavigation_CategoryNavigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45243);
/* harmony import */ var domain_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74692);






var ShopPage = function(param) {
    var categories = param.categories, pageMeta = param.pageMeta;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (categories.length) {
            var defaultCategory = categories.find(function(param) {
                var slug = param.slug;
                return slug === domain_constants__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_CATEGORY */ .x4;
            });
            if (defaultCategory) router.push("shop/".concat(domain_constants__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_CATEGORY */ .x4));
            else router.push("/shop/".concat(categories[0].slug));
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        pageMeta: pageMeta,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shop_CategoryNavigation_CategoryNavigation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            categories: categories
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ShopPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,351,690,774,888,179], function() { return __webpack_exec__(73276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);